module.exports = __webpack_public_path__ + "static/media/markers_new.8be98ed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client/markers_new.png
// module id = 1081
// module chunks = 114